import React from 'react';
import { TableCell, TableRow} from '@mui/material';
import Select from '@mui/material/Select';
import {OutlinedInput, MenuItem, Chip, Stack, TextField} from '@mui/material';
import styled from 'styled-components';


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const ButtonWrapper = styled.div`
  display: flex;
`


const EmailMasterEditable = ({k,row, editFormData, handleCancelClick,
   page, rowsPerPage, onChangeEditDesgn, SubmitButton, assetmaster, editCategory}) =>{
    return( <>
        <TableRow key={k} name={row.Category}>
           <TableCell component="th" scope="row">
           {(page)*(rowsPerPage)+k+1}
           </TableCell>
           
           <TableCell  align="left">
            <TextField
                  id="outlined-basic"
                  size='small'
                  type="text"
                  name={`emailmaster${(page)*(rowsPerPage)+k}`}
                  onChange={(event) => onChangeEditDesgn(event)}
                  label="Email Master"
                  value={editFormData[`emailmaster${(page)*(rowsPerPage)+k}`]}
                  variant="outlined"
                  sx={{backgroundColor:"white", width:"300px", height:"40px"}}
                />         
          </TableCell>             

          <TableCell align="left">
            <ButtonWrapper>
              <SubmitButton type="submit">Save</SubmitButton>
              <SubmitButton type="button" onClick={(e)=>handleCancelClick(e,k)}>Cancel</SubmitButton>
            </ButtonWrapper>                              
            </TableCell>
          </TableRow>     
        </>         
    )
}

export default EmailMasterEditable;